import Icon from "components/_UI/Icon";
import InfoTooltip from "components/_UI/InfoTooltip";
import Button from "components/_UI/Button";
import { STATUS_TYPES, STATUS_TRANSITIONS } from 'modules/_common/EstablishmentOrderStatusTypes';
import styled from "styled-components";
import colors from "theme/colors";

export default function EstablishmentOrderActionButtons({
    order,
    isIconButton = true,
    onClick = () => { }
}) {
    const ACTION_BUTTONS = {
        [STATUS_TYPES.REQUESTED.key]: [
            { nextStatus: STATUS_TYPES.PREPARING.key, label: 'Iniciar produção', variant: colors.primaryLight }
        ],
        [STATUS_TYPES.PREPARING.key]: [
            { nextStatus: STATUS_TYPES.READY_FOR_PICKUP.key, label: 'Pronto para retirada', variant: colors.primaryLight }
        ],
        [STATUS_TYPES.READY_FOR_PICKUP.key]: [
            { nextStatus: STATUS_TYPES.PICKED_UP.key, label: 'Retirado', variant: colors.primaryLight }
        ],
        [STATUS_TYPES.PICKED_UP.key]: [
            { nextStatus: null, label: 'Retirado', variant: colors.primaryLight }
        ],
    };

    const getAvailableActions = (currentStatus) => {
        return ACTION_BUTTONS[currentStatus] || [];
    };

    const canTransitionTo = (currentStatus, nextStatus) => {
        return STATUS_TRANSITIONS[currentStatus]?.includes(nextStatus) || false;
    };

    const handleStatusUpdate = async (order, newStatus) => {
        if (!canTransitionTo(order.status, newStatus)) {
            alert(`Cannot transition from ${order.status} to ${newStatus}`);
            return;
        }

        onClick(order);
    };

    return (
        <>
            {
                isIconButton && getAvailableActions(order.status).map(action => (
                    <InfoTooltip
                        bgColor={colors.night}
                        text={action.label}
                        type='none'
                    >
                        <StyledButton
                            onClick={action.nextStatus !== null ? () => handleStatusUpdate(order, action.nextStatus) : () => {}}
                        >
                            <Icon color={action.variant} name="check-point" />
                        </StyledButton>
                    </InfoTooltip>
                ))
            }

            {
                !isIconButton && getAvailableActions(order.status).map(action => (
                    <InfoTooltip
                        bgColor={colors.night}
                        text={action.label}
                        type='none'
                    >
                        <Button
                            category='squired'
                            variant='lightBlue'
                            onClick={action.nextStatus !== null ? () => handleStatusUpdate(order, action.nextStatus) : () => {}}
                        >
                            {action.label}
                        </Button>
                    </InfoTooltip>
                ))
            }
        </>
    );
}

const StyledButton = styled.div`
    margin-right: 8px;
    cursor: pointer;
    width: 20px;
    height: 20px;
`;